import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { ContentBlockRegion, IPlayableWidget } from 'src/app/core/models/content.model';
import { IContentBlockComponent } from '../content-block-component.model';

@Component({
  selector: 'air-playable-widget',
  templateUrl: './playable-widget.component.html',
  standalone: false
})
export class PlayableWidgetComponent implements IContentBlockComponent, AfterViewInit {
  @ViewChild('playableWidget') widgetElement: ElementRef<HTMLIFrameElement>;

  className = 'playable-widget';
  isFirst?: boolean;
  region?: ContentBlockRegion;
  content: IPlayableWidget;
  userEventSource: string;
  isLoading = true;

  private readonly baseUrl = 'https://air-miles.leadfamly.com/campaign/view/iframe/0/hash:{0}';

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.setWidgetAttributes();
  }

  private setWidgetAttributes(): void {
    if (!this.widgetElement?.nativeElement) {
      return;
    }

    let src = this.baseUrl;
    src = src.format([this.content.widgetHash]);

    this.widgetElement.nativeElement.src = src;
    this.isLoading = false;
    this.cdRef.detectChanges();
  }
}
